'use strict';

export default function f(currencyOptions) {
  'ngInject';

  this.options = currencyOptions;
}



// WEBPACK FOOTER //
// ./app/src/common/currency_select/currency_select.controller.js